<template>
    <div id="payment-method-card" class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-6">
        <div class="flex flex-wrap items-center justify-between gap-3">
            <h3 class="text-lg font-semibold text-gray-900">Payment method</h3>
            <button
                v-if="!paymentMethod"
                type="button"
                class="primaryButton !mt-0"
                @click="$emit('add-card')"
            >
                Add card
            </button>
        </div>

        <p class="mt-1 text-sm text-gray-500">This card on file will be used for active RentRisk subscriptions.</p>

        <div v-if="paymentMethod" class="mt-4 rounded-lg border border-gray-200 p-4">
            <div class="flex flex-wrap items-center justify-between gap-3">
                <div class="flex items-center gap-2 text-sm text-gray-700">
                    <font-awesome-icon :icon="faCreditCard" class="text-gray-400" aria-hidden="true" />
                    <span class="font-semibold uppercase">{{ paymentMethod.card_brand || 'Card' }}</span>
                    <span>ending {{ paymentMethod.last_4 }}</span>
                    <span class="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">Default</span>
                </div>
                <button
                    type="button"
                    class="text-sm font-medium text-red-600 hover:text-red-800"
                    @click="$emit('delete-card', paymentMethod.id)"
                >
                    Delete
                </button>
            </div>
            <p class="mt-1 text-sm text-gray-500">Expires {{ paymentMethod.exp_month }}/{{ paymentMethod.exp_year }}</p>
            <button type="button" class="whiteButton mt-3 w-full" @click="$emit('add-card')">Update card</button>
        </div>
        <p v-else class="mt-4 rounded-lg border border-dashed border-gray-300 p-4 text-sm text-gray-500">
            No card on file.
        </p>

        <div class="mt-6 border-t border-gray-100 pt-5">
            <div class="flex flex-wrap items-center justify-between gap-3">
                <div>
                    <p class="text-sm text-gray-500">Receipts sent to</p>
                    <p v-if="!editing" class="text-sm font-medium text-gray-900">{{ billingEmail }}</p>
                </div>
                <button
                    v-if="!editing"
                    type="button"
                    class="text-sm font-medium text-rent-risk-blue-400 hover:text-black"
                    @click="startEditing"
                >
                    Edit
                </button>
            </div>

            <form v-if="editing" class="mt-3" @submit.prevent="save">
                <label for="receipt-email" class="sr-only">Receipt email</label>
                <input
                    id="receipt-email"
                    v-model="form.billing_email"
                    type="email"
                    class="block w-full rounded-md border-gray-300 shadow-sm focus:border-rent-risk-blue-400 focus:ring-rent-risk-blue-400 sm:text-sm"
                    :class="form.errors.billing_email ? 'border-red-300' : ''"
                />
                <p v-if="form.errors.billing_email" class="mt-1 text-sm text-red-500">{{ form.errors.billing_email }}</p>
                <div class="mt-3 flex gap-2">
                    <button
                        type="submit"
                        class="primaryButton !mt-0"
                        :disabled="form.processing"
                    >
                        {{ form.processing ? 'Saving...' : 'Save' }}
                    </button>
                    <button
                        type="button"
                        class="whiteButton !mt-0"
                        @click="cancelEditing"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { useForm } from '@inertiajs/vue3';
import { faCreditCard } from '@fortawesome/pro-light-svg-icons';

export default {
    name: 'PaymentMethodCard',
    props: {
        paymentMethod: {
            type: Object,
            default: null,
        },
        billingEmail: {
            type: String,
            default: '',
        },
    },
    emits: ['add-card', 'delete-card'],
    data() {
        return {
            faCreditCard,
            editing: false,
            form: useForm({
                billing_email: this.billingEmail,
            }),
        };
    },
    methods: {
        startEditing() {
            this.form.billing_email = this.billingEmail;
            this.form.clearErrors();
            this.editing = true;
        },
        cancelEditing() {
            this.editing = false;
            this.form.clearErrors();
            this.form.billing_email = this.billingEmail;
        },
        save() {
            this.form.patch(this.route('billing.receipt-email'), {
                preserveScroll: true,
                onSuccess: () => {
                    this.editing = false;
                },
            });
        },
    },
};
</script>
